import { BusinessHomepageLayout } from "./BusinessHomepageLayout";
import { HomePage } from "./pages/HomePage";

export default function BusinessHomePage() {
	return (
		<BusinessHomepageLayout>
			<HomePage />
		</BusinessHomepageLayout>
	);
}
